// extracted by mini-css-extract-plugin
export var infoRow = "_sx-2";
export var labelContainer = "_sx-0";
export var rightInfo = "_sx-1";